import React from 'react';
import { ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-34">
      <div className="max-w-4xl mx-auto text-center" data-id="element-35">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#2D3436] mb-6 leading-tight" data-id="element-36">
          ¿Cuántas veces te prometiste que{' '}
          <span className="italic text-[#9CAF88]" data-id="element-37">"esta vez sí"</span>…
          <br data-id="element-38" />y otra vez lo dejaste?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-39">
          No porque seas débil. No porque no puedas.
          <br data-id="element-40" />
          <span className="font-semibold text-[#2D3436]" data-id="element-41">
            Sino porque nadie te enseñó cómo sostenerlo.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative mx-auto mb-12 max-w-md cursor-pointer group" onClick={scrollToCheckout} data-id="element-42">
          <div className="absolute inset-0 bg-[#9CAF88]/20 rounded-2xl transform rotate-3 transition-transform group-hover:rotate-6 duration-500" data-id="element-43"></div>
          <div className="absolute inset-0 bg-[#E8D5D5]/30 rounded-2xl transform -rotate-3 transition-transform group-hover:-rotate-6 duration-500" data-id="element-44"></div>
          <img src="https://cdn.magicpatterns.com/uploads/97DFhkMoqVSfzwTqVRHxx5/ChatGPT_Image_28_ene_2026,_18_45_57.png" alt="Yoga Esencial - De Cero a Práctica Consciente" className="relative rounded-2xl shadow-2xl w-full h-auto object-contain" data-id="element-45" />
        </motion.div>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToCheckout} className="bg-[#9CAF88] hover:bg-[#7A8C69] text-white text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 mx-auto" data-id="element-46">
          Quiero Empezar Mi Cambio Hoy
          <ArrowDown size={20} data-id="element-47" />
        </motion.button>
      </div>
    </section>;
}